// Auto-generated icon module
const svg = `<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
	<polygon points="4,20 8.5,20 8.5,21 3,21 3,15.5 4,15.5" />
	<polygon points="3,8.5 4,8.5 4,4 8.5,4 8.5,3 3,3" />
	<polygon points="20,20 15.5,20 15.5,21 21,21 21,15.5 20,15.5" />
	<polygon points="15.5,3 15.5,4 20,4 20,8.5 21,8.5 21,3" />
</svg>
`;

export { svg as default };
//# sourceMappingURL=it-fullscreen-NgS52jcd.js.map
